import { Capacitor } from '@capacitor/core';

export function isLocalRun(): boolean {
  if (import.meta.env.DEV) return true;
  return !Capacitor.isNativePlatform() && window.location.hostname === 'localhost';
}
